import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { ProviderInvoiceConceptModel } from 'src/app/models/shopping/provider-invoice-concept.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProviderInvoiceConceptService {

  private readonly _httpClient = inject(HttpClient);

  createProviderInvoiceConcept(providerInvoiceConcept: ProviderInvoiceConceptModel): Observable<ProviderInvoiceConceptModel> {
    return this._httpClient.post<ProviderInvoiceConceptModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.providerInvoiceConcept.CreateProviderInvoiceConcept}`,
      providerInvoiceConcept);
  }

  deleteProviderInvoiceConcept(providerInvoiceConceptId: number): Observable<ProviderInvoiceConceptModel> {
    const params = new HttpParams().set('providerInvoiceConceptId', providerInvoiceConceptId);
    return this._httpClient.delete<ProviderInvoiceConceptModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.providerInvoiceConcept.DeleteProviderInvoiceConcept}`,
      { params: params }
    );
  }

  exportGeneralConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());

    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.providerInvoiceConcept.ExportGeneralConsultation}`, filters, {
      params,
      responseType: 'blob',
    });
  }

  getColumnsForGeneralConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.providerInvoiceConcept.GetColumnsForGeneralConsultation}`);
  }

  getProviderInvoiceConceptById(providerInvoiceConceptId: number): Observable<ProviderInvoiceConceptModel> {
    const params = new HttpParams().set('providerInvoiceConceptId', providerInvoiceConceptId);
    return this._httpClient.get<ProviderInvoiceConceptModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.providerInvoiceConcept.GetProviderInvoiceConceptById}`,
      { params: params }
    );
  }

  getProviderInvoiceConceptsForGeneralConsultation(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams()
      .set('page', page)
      .set('limit', limit)
      .set('columnSort', columnSort || '')
      .set('ascendant', ascendant);

    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.providerInvoiceConcept.GetProviderInvoiceConceptsForGeneralConsultation}`,
      filters, { params: params }
    );
  }

  updateProviderInvoiceConcept(providerInvoiceConcept: ProviderInvoiceConceptModel): Observable<ProviderInvoiceConceptModel> {
    return this._httpClient.put<ProviderInvoiceConceptModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.providerInvoiceConcept.UpdateProviderInvoiceConcept}`,
      providerInvoiceConcept);
  }
}
